export const I18N_NAMESPACES = [
  'common',
  'auth',
  'navigation',
  'trees',
  'members',
  'canvas',
  'settings',
  'admin',
  'invites',
  'validation',
  'ai',
] as const;

export type I18nNamespace = typeof I18N_NAMESPACES[number];

export const DEFAULT_NAMESPACE: I18nNamespace = 'common';

